import { generateBridge } from '../Utility/GenerateBridge';

export type MainBridgeSync = {
    getDeviceLocale: () => ILocale;
    getEntryPointData: () => object;
    getDeviceId: () => string;
    openMarket: VoidFunction;
    showReviewOverlay: () => boolean;
    openUrl: (url: string) => void;
    sendEmail: (payload: { email: string; subject: string }) => void;
    getServerTime: () => number;
    closeSplashScreen: () => void;
    quitGame: () => void;
    hasConnectionToNetwork: () => boolean;
};

export type MainBridgeEvents = {
    sendAttribution: (
        trackerToken: string,
        trackerName: string,
        network: string,
        campaign: string,
        adgroup: string,
        creative: string,
        clickLabel: string,
        adid: string
    ) => void;
    handleNavigationBack: () => void;
};

export interface ILocale {
    languageCode: string;
    country: string;
}

export const Main = generateBridge({
    name: 'Main',
    sync: {
        getDeviceLocale: undefined,
        getEntryPointData: undefined,
        getDeviceId: undefined,
        openMarket: undefined,
        showReviewOverlay: undefined,
        openUrl: undefined,
        sendEmail: undefined,
        getServerTime: undefined,
        closeSplashScreen: undefined,
        quitGame: undefined,
        hasConnectionToNetwork: undefined,
    },
    async: {},
    event: {
        sendAttribution: undefined,
        handleNavigationBack: undefined,
    },
});
